import 'url-search-params-polyfill';

import Vue from 'vue'
import Vuex from 'vuex'

import HeaderModule from '@/store/modules/HeaderModule'
import MenuModule from '@/store/modules/MenuModule'
import QuestionModule from '@/store/modules/QuestionModule'
import WordModule from '@/store/modules/WordModule'
import MovieModule from '@/store/modules/MovieModule'
import WebGisModule from '@/store/modules/WebGisModule'
import MapModule from '@/store/modules/MapModule'
import TimelineModule from '@/store/modules/TimelineModule'
import LinkModule from '@/store/modules/LinkModule'
import LawModule from '@/store/modules/LawModule'
import ImageModule from '@/store/modules/ImageModule'
import SampleModule from '@/store/modules/SampleModule'
import PracticeModule from '@/store/modules/PracticeModule'
import GeographModule from '@/store/modules/GeographModule'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentMenu: ""
  },
  mutations: {
  },
  modules: {
    HeaderModule,
    MenuModule,
    WordModule,
    QuestionModule,
    MovieModule,
    WebGisModule,
    MapModule,
    TimelineModule,
    LinkModule,
    LawModule,
    ImageModule,
    SampleModule,
    PracticeModule,
    GeographModule,
  },
  actions: {
    initQuestion (context) {
      context.commit("QuestionModule/initData")
    },
    initWord (context) {
      context.commit("WordModule/initData")
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js